import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconArrowLeftComponent } from "./med-icon-arrow-left.component";

@NgModule({
  declarations: [
    MedIconArrowLeftComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconArrowLeftComponent,
  ],
})
export class MedIconArrowLeftModule { }
